// cancelToken, not AbortController: apiClient uses the axios nested in @leap4/frontend
// (0.21.4), which predates config.signal and silently ignores it.
import axios, { CancelToken } from "axios";

export interface IRequestCancellationConfig {
    cancelToken: CancelToken;
}

export interface IRequestCancellation {

    config: IRequestCancellationConfig;
    cancel(message?: string): void;
}

export function createRequestCancellation(): IRequestCancellation {
    const source = axios.CancelToken.source();
    return {
        config: { cancelToken: source.token },
        cancel: (message?: string) => source.cancel(message),
    };
}
